import EventsGrouped from './EventsGroups';
import time from 'utils/time';

const getEventDateKey = (item) => time.getCalendarDateKey(item.eventStartDate ?? item.dateTime);

const EventsGroupedByDate = (events, feedItemFlags) => {
  const dates = [];
  events.forEach((item) => {
    const dateKey = getEventDateKey(item);
    if (!dates.includes(dateKey)) {
      dates.push(dateKey);
    }
  });
  events.forEach((item, index) => {
    if (feedItemFlags) {
      return (item.feedItemFlags = feedItemFlags[index]);
    }
  });
  const Events = {};
  dates.forEach((item) => {
    Events[item] = [];
  });
  events.forEach((item) => {
    Events[getEventDateKey(item)].push(item);
  });
  return Events;
};

const EventsCategoriesInsideDates = (events, feedItemFlags) => {
  const eventsGrouped = EventsGroupedByDate(events, feedItemFlags);
  for (var i in eventsGrouped) {
    eventsGrouped[i] = EventsGrouped(eventsGrouped[i]);
  }
  return eventsGrouped;
};

export default EventsCategoriesInsideDates;
